export default "__VITE_ASSET__VI7_3BwD__"